import {
  Box,
} from "@mui/material";
import { useEffect, useState } from "react";
import "./Facility.scss";
import ErrorPopup from "../../dialogBox/errorModal";
import SuccessDialog from "../../dialogBox/successDialog";
import { FacilityList } from "./FacillityList";
import { FacilityInputWizard } from "./FacilityInputWizard";
import store from "../../../store/store";
import { searchFacilities } from "../../../store/api/facility";
import { getUserContext } from "../../../shared/utils/utils";

const Facility = () => {
  const [pageMode, setPageMode] = useState<"VIEW" | "ADD" | "EDIT">("VIEW");
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [facilities, setFacilities] = useState<any[]>([]);
  const [success, setSuccess] = useState({ open: false, message: '' });
  const [error, setError] = useState({ open: false, message: '' });

  const userContext:any = getUserContext();
  const orgPartyId = userContext?.orgPartyIds?.[0]
  
  const pageSize = 10;
  const [pageNumber, setPageNumber] = useState<number>(1);

  const getFacilities = () => {
    const queryParams = {
      page: pageNumber,
      pageSize: pageSize,
    }
    const reqBody = {
      facilityTypeId:"", parentFacilityId:"", facilityId:"", ownerPartyId:orgPartyId, text:""
    }
    store.dispatch(searchFacilities({queryParams, reqBody})).unwrap()
    .then((res) => {
      setFacilities(res?.data?.facilities);
    })
    .catch((error) => {
      console.log("Error occurred while fetching facilities", error);
      handleSetError(error?.error);
    })
  }

  useEffect(() => {
    getFacilities();
  }, [pageNumber, pageSize]);

  const handleUpdate = (facility: any) => {
    setSelectedFacility(facility);
    setPageMode("EDIT");
  };

  const handleAdd = () => {
    setPageMode("ADD");
  };
  const handleCancelClick = () => {
    setPageMode("VIEW");
    setSelectedFacility(null);
  }
  const addFacility = (reqBody: any) => {
    // setFacilities((prevState) => [...prevState, reqBody]);
    getFacilities();
  }

  const editFacility = (reqBody: any) => {
    // const currFacilities = facilities.filter((facility: any) => facility._id != reqBody._id);
    // setFacilities((prevState) => [...currFacilities, reqBody]);
    getFacilities();
    handleCancelClick();
  }
  const handleCloseError = () => {
    setError({ ...error, open: false });
  };
  const handleCloseSuccess = () => {
    setSuccess({ ...error, open: false });
  };
  const handleSetSuccess = (message: string) => {
    setSuccess({ message, open: true })
  }
  const handleSetError = (message: string) => {
    setError({ message, open: true })
  }
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    if (value !== pageNumber) {
      setPageNumber(value);
    }
  };
  return (
    <>
      <Box className="facilityMainContainer">
        {pageMode === "VIEW" && (
          <FacilityList
            handleUpdate={handleUpdate}
            handleAdd={handleAdd}
            facilities={facilities}
            pageNumber={pageNumber}
            pageLimit={pageSize}
            handlePageChange={handlePageChange}
          />
        )}

        {(pageMode === "ADD" || pageMode === "EDIT") && (
          <FacilityInputWizard
            pageMode={pageMode}
            selectedFacility={selectedFacility}
            handleCancelClick={handleCancelClick}
            addFacility={addFacility}
            editFacility={editFacility}
            handleSetSuccess={handleSetSuccess}
            handleSetError={handleSetError}
          />
        )}
      </Box>
      <ErrorPopup
        open={error.open}
        message={error.message}
        onClose={handleCloseError}
      />
      <SuccessDialog
        open={success.open}
        message={success.message}
        onClose={handleCloseSuccess}
      />
    </>
  );
};

export default Facility;



